import { APIDataDepartmentUserThrough, APIMetaDataDepartmentUserThroughPropertyNames } from '@evertel/types'
import { Store } from '@evertel/types'
import { decorate, injectable } from '@evertel/di'

export type DepartmentAccess = APIDataDepartmentUserThrough

class DepartmentsAccessStore extends Store<APIDataDepartmentUserThrough> {
    constructor() {
        super(APIMetaDataDepartmentUserThroughPropertyNames)
    }

    // override update(...args) {
    //     console.log('====================== Updating department access:', args)
    //     return super.update(...args)
    // }

}

decorate(injectable(), DepartmentsAccessStore)

export { DepartmentsAccessStore }
